import type { PipeTransform } from '@angular/core';

import { Pipe } from '@angular/core';

@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {
  transform(bytes: number, decimals = 2): any {
    let result: string | undefined = undefined;

    if (bytes) {
      const k = 1024;
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      const sizes = ['octets', 'Ko', 'Mo', 'Go'];
      result = `${Number.parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))}\u00A0${sizes[i]}`;
    }

    return result;
  }
}
